import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 查询配置表以及最新更新时间
const getAllLangConf = obj => new Promise((resolve, reject) => {
    const {
        form,
        token
    } = obj
    request({
        url: apis.lang_conf_get_all + '?token=' + token,
        data: form
    }).then(res => {
        resolve(res);
    })
})

const collectTypes = obj =>new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.lang_conf_types + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
})

const exportJson = obj => new Promise((resolve, reject) => {
    const {
        token,
        lang
    } = obj
    request({
        url: apis.lang_conf_export + '?token=' + token+'&lang=' + lang,
    }).then(res => {
        resolve(res);
    })
})

const downloadExcel = obj =>  new Promise((resolve, reject) => {
    window.location.href = apis.lang_conf_excel_download;
})

const downloadVerifyExcel = obj =>  new Promise((resolve, reject) => {
    window.location.href = apis.verify_down_verify_excel;
})

const getVerifyList = obj => new Promise((resolve, reject) => {
    const {
        langStatus,
        token
    } = obj;
    request({
        url: apis.verify_get_list + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

const getUncheckData = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.verify_get_uncheck_data + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});


const verifyFinish = obj => new Promise((resolve, reject) => {
    const {
        verifyForm,
        token
    } = obj;
    request({
        url: apis.verify_finish + '?token=' + token,
        data : verifyForm,
    }).then(res => {
        resolve(res);
    })
});

const verifyRevert = obj => new Promise((resolve, reject) => {
    const {
        i18nId,
        token
    } = obj;
    request({
        url: apis.verify_back + '?token=' + token+"&id="+i18nId,
    }).then(res => {
        resolve(res);
    })
});

const oneClickVerify = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.verify_one_click + '?token=' + token,
    }).then(res => {
        resolve(res);
    })
});

// 上传语言包到OSS
const uploadToOSS = obj => new Promise((resolve, reject) => {
    const {
        token,
        lang,
        version
    } = obj
    request({
        url: apis.lang_conf_oss_upload + '?token=' + token +'&lang=' + lang + '&version=' + version,
    }).then(res => {
        resolve(res);
    })
})

// 获取源初境冠军
const getAllChampionRecord = obj => new Promise((resolve, reject) => {
    const {
        allChampionRecordForm,
        token
    } = obj;
    request({
        url: apis.get_all_champion_record + '?token=' + token,
        data : allChampionRecordForm,
    }).then(res => {
        resolve(res);
    })
});

// 获取源初境冠军(新)
const recordByRealmSeason = obj => new Promise((resolve, reject) => {
    const {
        recordByRealmSeasonForm,
        token
    } = obj;
    request({
        url: apis.record_by_realm_season + '?token=' + token,
        data : recordByRealmSeasonForm,
    }).then(res => {
        resolve(res);
    })
});

// 导出非中文版本的差异项全量Excel
const exportCompareCurrentVersion = obj =>  new Promise((resolve, reject) => {
    const {
        lang,
    } = obj;
    window.location.href = apis.compare_current_version+ '?lang=' + lang;
})

// 导出非中文版本的差异项全量Excel(海外)
const compareOversea = obj =>  new Promise((resolve, reject) => {
    const {
        lang,
    } = obj;
    window.location.href = apis.compare_oversea+ '?lang=' + lang;
})

// 导出非中文版本的差异项全量csv
const exportCompareCurrentVersionCsv = obj =>  new Promise((resolve, reject) => {
    const {
        lang,
    } = obj;
    window.location.href = apis.compare_current_version_csv+ '?lang=' + lang;
})

// 导出非中文版本的差异项全量csv(海外)
const compareOverseaCsv = obj =>  new Promise((resolve, reject) => {
    const {
        lang,
    } = obj;
    window.location.href = apis.compare_oversea_csv+ '?lang=' + lang;
})


export default {
    getAllLangConf,
    exportJson,
    downloadExcel,
    collectTypes,
    getVerifyList,
    verifyFinish,
    verifyRevert,
    downloadVerifyExcel,
    getUncheckData,
    oneClickVerify,
    uploadToOSS,
    getAllChampionRecord,
    recordByRealmSeason,
    exportCompareCurrentVersion,
    compareOversea,
    exportCompareCurrentVersionCsv,
    compareOverseaCsv
}



// WEBPACK FOOTER //
// ./src/service/lang_conf_api.js